import React from 'react';

const discordIcon = (
    fill: string,
    size: number,
    style?: React.CSSProperties,
) => (
    <svg
        aria-hidden="true"
        data-testid="test-icon"
        fill="none"
        height={size}
        viewBox="0 0 24 24"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
        style={style}
    >
        <title>discord icon</title>
        <path
            d="M10.1087 10.987C9.51259 10.987 9.04294 11.5214 9.04294 12.1739C9.04294 12.8241 9.52359 13.3608 10.1087 13.3608C10.7038 13.3608 11.1734 12.8241 11.1734 12.1739C11.1855 11.5203 10.7038 10.987 10.1087 10.987ZM13.9232 10.987C13.327 10.987 12.8574 11.5214 12.8574 12.1739C12.8574 12.8241 13.338 13.3608 13.9232 13.3608C14.5182 13.3608 14.9879 12.8241 14.9879 12.1739C14.9868 11.5203 14.5182 10.987 13.9232 10.987Z"
            fill={fill}
        />
        <path
            d="M17.8585 4H6.14149C4.96131 4 4 4.98325 4 6.20162V17.2761C4 18.4945 4.96131 19.75 6.14149 19.75H15.7049L15.1495 17.4989L16.488 18.7713L17.7518 19.9683L20 22V6.20162C20 4.98325 19.0387 4 17.8585 4ZM14.967 15.9775C14.967 15.9775 14.5908 15.5185 14.2784 15.1101C15.6467 14.7141 16.1691 13.8389 16.1691 13.8389C15.7402 14.1269 15.3332 14.3316 14.967 14.4711C14.4445 14.6939 13.9441 14.8435 13.4524 14.9301C12.4493 15.1214 11.5298 15.0685 10.7456 14.9189C10.1505 14.8008 9.63908 14.6297 9.21012 14.4576C8.97035 14.362 8.70747 14.2461 8.4479 14.0965C8.416 14.0729 8.3852 14.0639 8.35441 14.0425C8.33241 14.0313 8.32251 14.0211 8.31151 14.0087C8.12343 13.903 8.01894 13.8287 8.01894 13.8287C8.01894 13.8287 8.52049 14.6837 9.84806 15.0899C9.53459 15.4949 9.14743 15.9775 9.14743 15.9775C6.83875 15.9021 5.96214 14.353 5.96214 14.353C5.96214 10.9116 7.46679 8.12275 7.46679 8.12275C8.97145 6.96738 10.4024 7 10.4024 7L10.5069 7.12825C8.62608 7.68512 7.75826 8.52888 7.75826 8.52888C7.75826 8.52888 7.98924 8.40062 8.3753 8.2195C9.49279 7.71775 10.3804 7.57825 10.7467 7.54562C10.8094 7.5355 10.8622 7.52425 10.9249 7.52425C11.5628 7.43875 12.2832 7.41738 13.0344 7.50288C14.0277 7.621 15.0945 7.92025 16.1801 8.52888C16.1801 8.52888 15.3541 7.72787 13.5778 7.17212L13.7241 7.00113C13.7241 7.00113 15.1561 6.9685 16.6597 8.12387C16.6597 8.12387 18.1643 10.9128 18.1643 14.3541C18.1643 14.3541 17.2767 15.9021 14.967 15.9775Z"
            fill={fill}
        />
    </svg>
);
export default discordIcon;
